import React from "react";
import { Link } from "react-router-dom";
import "./ServicesDetail.css";
import postSurgicalImg from "../../assets/images/postSurgical.jpg";

function PostSurgicalPT() {
  return (
    <div className="service-detail-container">
      <div className="service-detail-image">
        <img src={postSurgicalImg} alt="Post Surgical Physical Therapy" />
      </div>
      <div className="service-detail-content">
        <h2>Post Surgical Physical Therapy</h2>
        <p>
          Our post-surgical rehabilitation programs are designed to ensure a
          smooth recovery process, minimize pain, and restore optimal function.
        </p>
        <p>
          <strong>When is it needed?</strong>
          If you’ve undergone orthopaedic surgery, joint replacement, or any invasive
          procedure requiring rehabilitative care, post-surgical PT can help speed up
          your return to daily life.
        </p>
        <ul className="service-bullet-list">
          <li>Rebuild strength and flexibility</li>
          <li>Pain management and mobility exercises</li>
          <li>Safe progression to normal activities</li>
        </ul>
        <p>
          We focus on gradual progression, personalized treatment plans, and continuous
          assessment to ensure you're healing safely and effectively.
        </p>

        <Link to="/contact" className="service-cta-button">
          Contact Us to Learn More
        </Link>
      </div>
    </div>
  );
}

export default PostSurgicalPT;
